export const GA_MEASUREMENT_ID = "G-T9M7DDZLHX";

const sendGtag = (...args) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag(...args);
};

export const trackEvent = (eventName, parameters = {}) => {
  sendGtag("event", eventName, {
    page_path: window.location.pathname,
    page_location: window.location.href,
    ...parameters,
  });
};

export const trackWhatsAppClick = (source, extraParameters = {}) => {
  trackEvent("whatsapp_click", {
    event_category: "contacto",
    click_source: source,
    ...extraParameters,
  });
};

export const trackCourseMoreInfoClick = (courseName, source) => {
  trackEvent("course_more_info_click", {
    event_category: "curso",
    course_name: courseName,
    click_source: source,
  });
};

export const trackCourseDownload = (courseName, fileName, source) => {
  trackEvent("course_pdf_download", {
    event_category: "descarga",
    course_name: courseName,
    file_name: fileName,
    click_source: source,
  });
};

export const trackLeadFormSubmit = (courseName) => {
  trackEvent("generate_lead", {
    event_category: "contacto",
    form_name: "solicita_informacion_cursos",
    course_interest: courseName || "sin_especificar",
  });
};

export const trackPageView = (path) => {
  sendGtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
